export default "__VITE_ASSET__0f30e396__"